import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { customer, CustomerService } from '../customer.service';
@Component({
  selector: 'app-add-customer',
  templateUrl: './add-customer.component.html',
  styleUrls: ['./add-customer.component.css']
})
export class AddCustomerComponent implements OnInit {
  dataSource = new MatTableDataSource<customer>();
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  isEdit: boolean = false;
  idCustomer!: number
  dayOfWeek: any[] = [
    { id: 1, name: 'จันทร์' }, { id: 2, name: 'อังคาร' },
    { id: 3, name: 'วันพุธ' }, { id: 4, name: 'วันพฤหัสบดี' },
    { id: 5, name: 'วันศุกร์' }, { id: 6, name: 'วันเสาร์' },
    { id: 7, name: 'วันอาทิตย์' },{ id: 0, name: '-' }]
  constructor(private customerService: CustomerService) { }

  ngOnInit(): void {
    this.getAll();
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }
  formCustomer = new FormGroup({
    name: new FormControl(''),
    address: new FormControl(''),
    day_of_week: new FormControl(1),
    phone_number: new FormControl(''),
  })
  displayedColumns: string[] = ['name', 'address', 'day_of_week', 'option'];
  submit() {
    let data = this.formCustomer.value
    data.day_of_week = Number(data.day_of_week)
    this.customerService.newAccount(data).subscribe((data) => {
      this.getAll();
      this.formCustomer.reset();
    }, (err) => {
      console.log('newAccount', err);
    })
  }
  update() {
    let data = this.formCustomer.value
    data.id = this.idCustomer;
    data.day_of_week = Number(data.day_of_week);
    this.customerService.update(data).subscribe((data) => {
      this.getAll();
    },
      (err) => {
        console.log('update', err);
      })
    this.formCustomer.reset();
    this.isEdit = false;
  }
  getAll() {
    this.customerService.getAll().subscribe((data) => {
      const sort = data.sort((a, b) => { return a.day_of_week - b.day_of_week })
      this.dataSource = new MatTableDataSource(sort);
      this.dataSource.paginator = this.paginator;
    },
      (err) => {
        console.log('getAll', err);
      })
  }
  day(i: number) {
    let d = this.dayOfWeek.find(({ id }) => id == i)
    return d.name
  }
  edit(element: customer) {
    this.isEdit = true;
    this.idCustomer = element.id;
    this.formCustomer.patchValue({
      name: element.name,
      address: element.address,
      day_of_week: String(element.day_of_week)
    });
  }
  cancelEdit() {
    this.isEdit = false;
    this.formCustomer.reset();
  }
}
